import header_component from './header_component';
import footer_component from './footer_component';

export default {
	header_component,
	footer_component,
};
